import instance from './instance';

export async function postPartnership(form: FormData) {
  const response = await instance.post('partnership', form);

  return response;
}
